import { dbh_ajax } from "../src/dbh_ajax";

export class dbh_kalender {
    private isWohngruppe: boolean;

    constructor(_isWohngruppe: boolean = false) {
        this.isWohngruppe = _isWohngruppe;
    }

    drawCalendar(start, ende, modifier, right, jump) {
        var me = this;
        $("#kalender").empty();
        $("#kalender").append(`<div class="loader"></div>`);
        if (right) {
            $("#tage").css("left", `-${jump * 50}px`);

            let a = $(`<div class="date"></div>`);
            let b = $(`<div class="pfeil">&#8249;</div>`);
            $(b).click(function () { me.drawCalendar(start, ende, modifier - jump, true, jump); });
            $(a).append(b);
            if (!this.isWohngruppe) {
                /*Download für kalender hinzufügen*/
                $(a).append("<div class='kDownload' title='Kalendar downloaden'></div>");
            }
            $("#kalender").append(a);
        }
        else if (right == false) {
            $("#tage").css("left", "0px");
            let a = $(`<div class="date"></div>`);
            let b = $(`<div class="pfeil">&#8249;</div>`);
            $(b).click(function () { me.drawCalendar(start, ende, modifier, true, jump); });
            $(a).append(b);
            if (!this.isWohngruppe) {
                /*Download für kalender hinzufügen*/
                $(a).append("<div class='kDownload' title='Kalendar downloaden'></div>");
            }
            $("#kalender").append(a);
        }
        else {
            $("#tage").css("left", `-${jump * 50}px`);
            let a = $(`<div class="date"></div>`);
            let b = $(`<div class="pfeil rechts">&#8249;</div>`);
            $(b).click(function () { me.drawCalendar(start, ende, modifier - jump, true, jump); });
            $(a).append(b);

            if (!this.isWohngruppe) {  /*Download für kalender hinzufügen*/
                $(a).append("<div class='kDownload' title='Kalendar downloaden'></div>");
            }
            $("#kalender").append(a);
        }

        $(".kDownload").on("click", function () {
            window.open('/DownloadKalendar', '_blank');
        })

        $("#kalender").append(`<div id="anzeige"><div id="tage"></div></div>`)
        var hatWechsel = false;
        var startTemp = start;
        var endeTemp = ende;
        if (right) {
            endeTemp = ende - jump;
        }
        else {
            startTemp = start + jump;
        }
        for (var j = startTemp; j < endeTemp - 2; j++) {
            date = new Date(Date.now());
            date.setDate(date.getDate() + modifier + j);
            if (date.getDate() == 1) {
                hatWechsel = true;
            }
        }
        for (var i = start; i < ende; i++) {
            var date = new Date(Date.now());
            date.setDate(date.getDate() + modifier + i);
            date.getMonth();
            var id = "dbhKalenderTag" + i;
            var eintrag = `<div class="date" id="${id}"><div class="month"`;
            if ((date.getDate() == 1 && i >= startTemp) || (i == startTemp && !hatWechsel)) {
                eintrag += `title="${this.getMonth(date.getMonth())} ${date.getFullYear()}"><svg width="11" height="14"><polygon points="0,14 11,7.5 0,0"style="fill:#FFC323;stroke-width:0;"/></svg>`;
                if (i < ende - 2) {
                    eintrag += `<span> ${this.getMonth(date.getMonth())} ${date.getFullYear()}</span>`;
                }
            } else {
                eintrag += `>`;
            }
            eintrag += `</div><div class="border"></div><div class="day`;
            switch (date.getDay()) {
                case 0:
                    eintrag += ` weekend">So`;
                    break;
                case 1:
                    eintrag += ` weekday">Mo`;
                    break;
                case 2:
                    eintrag += ` weekday">Di`;
                    break;
                case 3:
                    eintrag += ` weekday">Mi`;
                    break;
                case 4:
                    eintrag += ` weekday">Do`;
                    break;
                case 5:
                    eintrag += ` weekday">Fr`;
                    break;
                case 6:
                    eintrag += ` weekend">Sa`;
                    break;
            }

            eintrag += `</div><div id="${date.getDate()}a${date.getMonth() + 1}a${date.getFullYear()}" class="number`
            if (date.getMonth() != new Date(Date.now()).getMonth()) { eintrag += " lastMonth"; }
            else if (i + modifier == 0) {
                eintrag += ` today`;
            }

            eintrag += `" onclick="var t = this.id; var regex = /a/ig; var x = t.replace(regex, '.'); if($('#'+t).hasClass('special')){var v = $('#'+t+' .tooltip').text();}">${date.getDate()}</div></div>`;
            //eintrag += `" onclick="var t = this.id; var regex = /a/ig; var x = t.replace(regex, '.'); console.log(x); if($('#'+t).hasClass('special')){var v = $('#'+t+' .tooltip').text();console.log(v);}">${date.getDate()}</div></div>`;

            $("#tage").append(eintrag);
        }
        if (right == false) {
            let a = $(`<div class="date"></div>`);
            let b = $(`<div class="pfeil">&#8250;</div>`);
            $(b).click(function () { me.drawCalendar(start, ende, modifier + jump, false, jump); });
            $(a).append(b);
            $("#kalender").append(a);
        }
        else {
            let a = $(`<div class="date"></div>`);
            let b = $(`<div class="pfeil">&#8250;</div>`);
            $(b).click(function () { me.drawCalendar(start, ende, modifier, false, jump); });
            $(a).append(b);
            $("#kalender").append(a);
        }

        let url = '/LoadKalender';
        if (this.isWohngruppe) { url = '/Wohngruppen/LoadKalender'; }

        var WG = this.isWohngruppe;
        $.ajax({
            type: 'POST',
            url: url,
            dataType: 'json',
            data: { 'start': start, 'ende': ende, 'modifier': modifier },
            success: function (data) {
                $.each(data, function (i, item) {
                    var datum = new Date(item.date);
                    var id = `#${datum.getDate()}a${datum.getMonth() + 1}a${datum.getFullYear()}`;
                    $(id).addClass("special");
                    $(id).attr("title", item.beschreibung.join("\n"));
                    var tmp = item.beschreibung.toString();
                    var regex = /,/ig;
                    var x = tmp.replace(regex, '<br>');
                    $(id).append(`<span class="tooltip">${x}</span>`);

                    $(id).on("click", function (e: Event) {
                        new dbh_kalender(WG).openPopupForDate(datum);
                        let tag = datum.getDate().toString();
                        if (tag.length == 1) {
                            tag = "0" + tag;
                        }
                    });
                });
                $(".loader").hide();
            },
            error: function (response) {
                console.log(response);
                $(".loader").hide();
                $("#kalender").append(`<img src="/styles/Images/Fehler.png" id="Fehler" title="Service derzeit nicht verfügbar."/>`);
            }
        });

        if (right) {
            $("#tage").animate({ left: "0px" });
        }
        else if (right == false) {
            $("#tage").animate({ left: `-${jump * 50}px` });
        }
    }

    getMonth(month) {
        switch (month) {
            case 0:
                return "Januar ";
            case 1:
                return "Februar ";
            case 2:
                return "März ";
            case 3:
                return "April ";
            case 4:
                return "Mai ";
            case 5:
                return "Juni ";
            case 6:
                return "Juli ";
            case 7:
                return "August ";
            case 8:
                return "September ";
            case 9:
                return "Oktober ";
            case 10:
                return "November ";
            case 11:
                return "Dezember ";
        }
    }

    computeCalendar() {
        var width = $('#kalender').outerWidth(false);//CSS-Width + padding + border (ohne Margin)
        var start = -7;
        if (width < 950) {
            start = -3
        }
        if (width < 550) {
            start = 0;
        }
        width = Math.floor(width);
        var count = (width - 100) / 50;
        count = Math.floor(count);
        var rest = width - (count * 50) - 100;
        if (rest < 40) {
            count--;
            rest += 50;
        }
        rest -= 2;
        var padding = rest / 2;

        $("#kalender").css("padding-left", padding);
        if (padding * 2 == rest) {
            $("#kalender").css("padding-right", padding);
        } else {
            $("#kalender").css("padding-right", (padding + 1));
        }

        var ende = count + start;
        var jump = Math.min(count, 10);
        ende += 10;
        this.drawCalendar(start, ende, 0, true, jump);
    }

    openPopupForDate(datum: Date) {
        console.log(this.isWohngruppe);
        if (this.isWohngruppe) {
            new dbh_ajax().sendGetRequest({
                actionName: "KalenderTermine",
                controllerName: "Wohngruppen",
                parameter: [["datum", datum.getDate() + "." + (datum.getMonth() + 1) + "." + datum.getFullYear()]],
                callbackSuccess: (ajaxResult: any) => {
                    $('#popup-placeholder').html(ajaxResult.responseText);

                    const day = datum.getDate() < 10 ? `0${datum.getDate()}` : `${datum.getDate()}`;
                    const month = (datum.getMonth() + 1) < 10 ? `0${(datum.getMonth() + 1)}` : `${(datum.getMonth() + 1)}`;

                    (window as any).showPopup('PopupTagebuchAufgabenTermine');
                },
                callbackError: (ajaxResult: object) => {
                }
            });
        }
        else {
            new dbh_ajax().sendGetRequest({
                actionName: "KalenderTermine",
                controllerName: "",
                parameter: [["datum", datum.getDate() + "." + (datum.getMonth() + 1) + "." + datum.getFullYear()]],
                callbackSuccess: (ajaxResult: any) => {
                    $('#popup-placeholderDashboardKalenderTermine').html(ajaxResult.responseText);

                    const day = datum.getDate() < 10 ? `0${datum.getDate()}` : `${datum.getDate()}`;
                    const month = (datum.getMonth() + 1) < 10 ? `0${(datum.getMonth() + 1)}` : `${(datum.getMonth() + 1)}`;

                    $('#dbhPopupKalenderTermineTitel').html(day + "." + month + "." + datum.getFullYear());
                    (window as any).showPopup('dbhPopupKalenderTermine');
                },
                callbackError: (ajaxResult: object) => {
                }
            });
        }
    }
}